import {contactDiagnosticLabels,safeContactDiagnostic} from '../../../lib/contactReadDiagnostics.js'
export default function ContactReadDiagnostic({value}) {
 const diagnostic=safeContactDiagnostic(value)
 if(!diagnostic)return null
 return <small style={{display:'block',marginTop:6}}>
  {contactDiagnosticLabels[diagnostic.code]}
  {diagnostic.requestId&&<span style={{display:'block'}}>Support reference: {diagnostic.requestId}</span>}
 </small>
}
